import SaleTagFour from './SaleTagFour';
import SaleTagSix from './SaleTagSix';
import SaleTagTwelve from './SaleTagTwelve';
import SaleTag04 from './SaleTag04';

export default {
  '0.0.4': SaleTagFour,
  '0.0.6': SaleTagSix,
  '0.0.12': SaleTagTwelve,
  '04': SaleTag04,
};
